import { render, staticRenderFns } from "./QaRejectFormulationPopUp.vue?vue&type=template&id=214418bd&scoped=true&"
import script from "./QaRejectFormulationPopUp.vue?vue&type=script&lang=js&"
export * from "./QaRejectFormulationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./QaRejectFormulationPopUp.vue?vue&type=style&index=0&id=214418bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214418bd",
  null
  
)

export default component.exports